module.exports = __webpack_public_path__ + "2c4c587045d61c4578b8acbe8f00e423.png";